import { Item } from "./ItemTypes";

export const items: Item[] = [
  {
    icon: <i className="fa-solid fa-shapes"></i>,
    content: "TypeScript",
  },
  {
    icon: <i className="fa-brands fa-react"></i>,
    content: "React",
  },
  {
    icon: <i className="fa-brands fa-git-alt"></i>,
    content: "Git",
  },
  {
    icon: <i className="fa-solid fa-server"></i>,
    content: "NestJS",
  },
  {
    icon: <i className="fa-solid fa-server"></i>,
    content: "ExpressJS",
  },
  {
    icon: <i className="fa-solid fa-server"></i>,
    content: "Fastify",
  },
  {
    icon: <i className="fa-brands fa-html5"></i>,
    content: "HTML",
  },
  {
    icon: <i className="fa-brands fa-css3-alt"></i>,
    content: "CSS",
  },
  {
    icon: <i className="fa-brands fa-js"></i>,
    content: "JavaScript",
  },
  {
    icon: <i className="fa-brands fa-docker"></i>,
    content: "Docker",
  },
  {
    icon: <i className="fa-solid fa-right-left"></i>,
    content: "Knex",
  },
  {
    icon: <i className="fa-solid fa-floppy-disk"></i>,
    content: "Tanstack Query",
  },
  {
    icon: <i className="fa-brands fa-css"></i>,
    content: "Tailwind CSS",
  },
  {
    icon: <i className="fa-solid fa-database"></i>,
    content: "PostgreSQL",
  },
  {
    icon: <i className="fa-solid fa-right-left"></i>,
    content: "Prisma ORM",
  },
  {
    icon: <i className="fa-solid fa-right-left"></i>,
    content: "Typeorm",
  },
  {
    icon: <i className="fa-solid fa-right-left"></i>,
    content: "Objection ORM",
  },
  {
    icon: <i className="fa-brands fa-wpforms"></i>,
    content: "React Hook Form",
  },
  {
    icon: <i className="fa-solid fa-database"></i>,
    content: "Zustand",
  },
  {
    icon: <i className="fa-solid fa-database"></i>,
    content: "Redux",
  },
  {
    icon: <i className="fa-solid fa-database"></i>,
    content: "Redux Toolkit",
  },
  {
    icon: <i className="fa-solid fa-book"></i>,
    content: "Storybook",
  },
];
